module.exports = __webpack_public_path__ + "static/scale-model-of-heritage-farmstead-museum-in-allen-texas-b063e63b9ec2e78e7d3e9e7e1cb86ad9.png";